import { render } from "./UserDetail.vue?vue&type=template&id=f21eb3ee&scoped=true&ts=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"

import "./UserDetail.vue?vue&type=style&index=0&id=f21eb3ee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21eb3ee"]])

export default __exports__